import React from 'react';
import './DetailsMain.css'
import Blackbtn from '../blackbtn/blackbtn';
import firstpic from '../../assets/first-pic.png'
import secpic from '../../assets/sec-pic.png'
import thirdpic from '../../assets/third-pic.png'
import location from '../../assets/location.svg'
import bed from '../../assets/bed.svg'
import bath from '../../assets/bath.svg'
import area from '../../assets/area.svg'
import park from '../../assets/park.svg'
import AmenitiesCon from '../details/AmenitiesCon';
import wifi from '../../assets/wifi.svg'
import pool from '../../assets/drop.svg'
import ac from '../../assets/ac.svg'
import security from '../../assets/security.svg'
import smart from '../../assets/smart.svg'
import garden from '../../assets/garden.svg'
import map from '../../assets/map.svg'
import profile from '../../assets/profilepic.png'
import call from '../../assets/call.svg'
import email from '../../assets/email.svg'
import { Link } from 'react-router-dom';
const DetailsMain = () => {
    return ( <>
    <div className='main-container'>
        <div className='pic-container'>
            <div className='title-container-2'>
                <div className='gap-title'>
            <p className='title-place'>Modern Luxury Villa</p>
            <div className='subtitle-box'>
                <img src={location} alt='/' />
            <p className='subtitle2'>123 Beverly Hills Drive, Los Angeles, CA 90210</p>
            </div>
            </div>
            <div className='number-container'>
            <p className='number'>$2,450,000</p>
            <Link to={"/vr"}>
                <Blackbtn name='View in VR' css1="blackbtn2" />
            </Link>
            </div>
            </div>
            <div className='pic-box'>
                <img className='pic1' src={firstpic} alt='/'/>
                <div className='small-pic-con'>
                <img className='pic2' src={secpic} alt='/' />
                <img className='pic2' src={thirdpic} alt='/' />
                </div>
            </div>
        </div>

        <div className='info-container'>
            <div className='details-box'>
                <div className='column'>
                    <img src={bed} alt='/' />
                    <p className='text'>5</p>
                    <p className='text'>Bedrooms</p>
                </div>

                <div className='column'>
                    <img src={bath} alt='/' />
                    <p className='text'>4</p>
                    <p className='text'>Bathrooms</p>
                </div>

                <div className='column'>
                    <img src={area} alt='/' />
                    <p className='text'>4,200 sq ft</p>
                    <p className='text'>Area</p>
                </div>

                <div className='column'>
                    <img src={park} alt='/' />
                    <p className='text'>3</p>
                    <p className='text'>Parking</p>
                </div>
            </div>
            <div className='textbox'>
            <p className='text'>Description</p>
            <p className='subtitle2'>Experience luxury living at its finest in this stunning modern villa. Featuring soaring ceilings, floor-to-ceiling windows, and an open-concept design that seamlessly blends indoor and outdoor spaces. The gourmet kitchen is equipped with top-of-the-line appliances, while the master suite offers a private retreat with spa-like bathroom and walk-in closet. Perfectly situated in one of Beverly Hills most prestigious neighborhoods.</p>
            </div>

            <div className='amenities'>
            <p className='text'>Amenities</p>
            <div className='box-am'>
            <AmenitiesCon icons={wifi} text='High-Speed WiFi' s3='btn3' />
            <AmenitiesCon icons={pool} text='Swimming Pool' s3='btn3' />
            <AmenitiesCon icons={ac} text='Central AC' s3='btn3' />
            </div>
            <div className='box-am'>
            <AmenitiesCon icons={security} text='Security System' s3='btn3' />
            <AmenitiesCon icons={smart} text='Smart Home' s3='btn3' />
            <AmenitiesCon icons={garden} text='Garden' s3='btn3' />
            </div>
            </div>
        </div>

        <div className='map-con'>
            <img className='map-pic' src={map} alt='/' />
            <div className='profile-box'>
                <div className='profile-container'>

                    <div className='first-box'>
                    <img src={profile} alt='/' />
                    <div className='column-box'>
                    <p className='name'>Amira Mohamed</p>
                    <p className='grey-text'>Licensed Agent</p>
                    </div>
                    </div>
                    <div className='column-box'>
                        <div className='row-profile'>
                            <img src={call} alt='/' />
                            <p className='grey-text'>+1 (310) 555-0123</p>
                        </div>
                        <div className='row-profile'>
                            <img src={email} alt='/' />
                            <p className='grey-text'>sarah.mitchell@estateflow.com</p>
                        </div>
                    </div>
                    <div className='btn-box'>
                    <Blackbtn css1='blackbtn4' name='Schedule Viewing' />
                    <Blackbtn css1='blackbtn3' name='Send Message' />
                    </div>
                </div>
            </div>
        </div>










    </div>
    </> );
}
 
export default DetailsMain;